import React, { useState, useEffect } from 'react';
import {
  Box, Button, FormControl, FormLabel, Input, Stack, Text, useToast, Heading, Flex, useColorModeValue,
} from '@chakra-ui/react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';

const ResetPasswordPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const toast = useToast();
  const bg = useColorModeValue('white', 'black');

  const [token, setToken] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const resetToken = searchParams.get('token');
    if (!resetToken) {
      toast({
        title: 'Invalid or missing token.',
        description: 'Please request a new password reset.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
      navigate('/forgot-password');
    } else {
      setToken(resetToken);
    }
  }, [location.search, toast, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirm) {
      toast({
        title: 'Passwords do not match.',
        status: 'error',
        duration: 4000,
        isClosable: true,
      });
      return;
    }

    try {
      const backendUrl = process.env.NODE_ENV === 'production'
        ? process.env.REACT_APP_BACKEND_URL
        : 'http://localhost:8080';

      await axios.post(`${backendUrl}/reset-password`, {
        token,
        new_password: password,
      });

      toast({
        title: 'Password updated!',
        description: 'You can now log in with your new password.',
        status: 'success',
        duration: 5000,
        isClosable: true,
      });
      navigate('/login');
    } catch (err) {
      console.error(err);
      toast({
        title: 'Error resetting password.',
        description: err.response?.data?.error || 'Please try again.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
  };
  console.log("Reset token:", token);

  return (
    <Flex minH={'100vh'} align={'center'} justify={'center'} bg={bg}>
      <Stack spacing={8} maxW={'md'} w={'full'} py={12} px={6}>
        <Stack align={'center'}>
          <Heading fontSize={'3xl'}>Set your new password</Heading>
        </Stack>
        <Box rounded={'lg'} bg={bg} boxShadow={'lg'} p={8}>
          <form onSubmit={handleSubmit}>
            <Stack spacing={4}>
              <FormControl isRequired>
                <FormLabel>New Password</FormLabel>
                <Input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </FormControl>
              <FormControl isRequired>
                <FormLabel>Confirm Password</FormLabel>
                <Input
                  type="password"
                  value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                />
              </FormControl>
              <Button type="submit" colorScheme="blue" width="full">
                Reset Password
              </Button>
            </Stack>
          </form>
        </Box>
      </Stack>
    </Flex>
  );
};

export default ResetPasswordPage;
